<div *ngIf="progress.hasImports()" class="import-progress-toast-container">
  <div
    *ngFor="let item of progress.imports(); trackBy: trackByImportId"
    class="import-progress-toast-item"
    [class.is-success]="item.status === 'completed'"
    [class.is-error]="item.status === 'failed'"
    [class.is-progress]="item.status === 'in_progress'"
  >
    <div
      *ngIf="item.status === 'in_progress'"
      class="import-progress-toast-overlay"
      [style.width.%]="percent(item)"
    ></div>

    <div class="import-progress-toast-content">
      <div class="import-progress-toast-header">
        <h4 class="import-progress-toast-title">
          @if (item.status === 'in_progress') {
            Importing {{ progress.importTypeLabel(item.importType) }}
          } @else if (item.status === 'completed') {
            {{ progress.importTypeLabel(item.importType) }} import finished
          } @else {
            {{ progress.importTypeLabel(item.importType) }} import failed
          }
        </h4>
        <button
          type="button"
          class="import-progress-toast-close"
          aria-label="Dismiss import progress"
          (click)="dismiss(item.importId)"
        >
          <icon-x class="h-4 w-4" />
        </button>
      </div>

      <div *ngIf="item.status === 'in_progress' || item.status === 'completed'" class="import-progress-section">
        <div class="import-progress-info">
          <span class="import-progress-text">
            {{ item.importedRecords }} of {{ item.totalRecords || '…' }} records
          </span>
          <span class="import-progress-percent">{{ percent(item) }}%</span>
        </div>
        <div class="import-progress-bar">
          <div
            class="import-progress-fill"
            [class.is-success]="item.status === 'completed'"
            [class.is-progress]="item.status === 'in_progress'"
            [style.width.%]="percent(item)"
          ></div>
        </div>
      </div>

      <p *ngIf="item.status === 'completed'" class="import-progress-status is-success">
        {{ item.message }}
      </p>
      <p *ngIf="item.status === 'failed'" class="import-progress-status is-error">
        {{ item.errorMessage || item.message }}
      </p>
    </div>
  </div>
</div>
